import { useEffect } from 'react';
import { Box, Container, Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Navigate } from 'react-router';

import { useUser } from '../../providers/UserContext';
import { useAuth } from '../../providers/AuthContext';
import { startInteractiveLogin } from '@/util/sessionRecovery';
import { usePageTitleDispatch } from '../../providers/PageTitleContext';
import { SET_PAGE_TITLE } from '../../providers/actionTypes';

const page_title = 'Login';

const Login = (): React.JSX.Element => {
  const user = useUser();
  const auth = useAuth();

  const pageTitleDispatch = usePageTitleDispatch();

  useEffect(() => {
    pageTitleDispatch({ type: SET_PAGE_TITLE, payload: page_title });
  }, [pageTitleDispatch]);

  return (
    <Box sx={{ display: 'flex' }}>
      <Container sx={{ padding: '15px' }}>
        <Grid container spacing={2} justifyContent='center' alignItems='center'>
          <Grid size={12} justifyContent='center' display='flex'>
            <Typography variant='body1'>
              Click the login button to begin.
            </Typography>
          </Grid>
          <Grid size={12} display='flex' justifyContent='center'>
            <Button
              onClick={() => {
                if (auth.user_manager) {
                  void startInteractiveLogin(auth.user_manager);
                }
              }}
              variant='contained'
            >
              Login
            </Button>
          </Grid>
        </Grid>
      </Container>
      {user && user?.entity_id && <Navigate to='/' replace />}
    </Box>
  );
};

export default Login;
